import React, { Fragment, useState, useEffect, useRef } from 'react';


import { format } from 'date-fns';
import { Button, Dropdown } from 'react-bootstrap';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import Cookies from 'js-cookie';
import "./ordersTable.css";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
const { config } = require('../api/api');


const MyHotelsTable = ({ VendorKey, Payload }) => {
  const base_url = config.baseURL;
  const redirectURL = config.redirectURL;
  const { t } = useTranslation();


  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(true);
  // const handleClose = () => setShow(false);

  const [odata, setOdata] = useState([]);
  const [orddata, setOrddata] = useState([]);
  const [selectedOption, setSelectedOption] = useState('Visa Orders');
  const [filter,setFilter]=useState('success');


  const handleClose = () => {
    setShow(false);
  };
  
  const lnstr = Cookies.get("langData") ? Cookies.get("langData") : "en";



  const [profile, setProfile] = useState(null);
  const [error, setError] = useState(null);


  const [totalEarnings, setTotalEarnings] = useState('');
  const [insuranceData, setInsuranceData] = useState([]);
  const [currentItems, currentItemsdata]= useState([]);
  const [totalPages, totalPagess]=useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10; // Number of items per page
  const [indexOfFirstItem, setindexOfFirstItem]= useState(0);
  const [indexOfLastItem, setIndexOfLastItem]= useState(0);

  const [iframeUrl, setIframeUrl] = useState("");
  const [iframeUrl1, setIframeUrl1] = useState("");
  const tableRef=useRef(null);
  const [pageChanged,setPageChanged]=useState(false);

  const [userData,setUserData] = useState(null);
  const [usrtok,setUsrtok]= useState("");
  const [orderNo,setOrderNo]=useState("")
  

  useEffect(() => {
    const urlSearchString = window.location.search;
    const uparams = new URLSearchParams(urlSearchString);
    const policy_no = uparams.get('order_id');
    setOrderNo(policy_no);
  }, []);

   useEffect(()=>{
      const storedUserString = Cookies.get('userData');
       if (storedUserString !== undefined) {
         const user_data = JSON.parse(storedUserString);
        setUserData(user_data);
         setUsrtok(user_data.access_token);
       }
       },[]);


  useEffect(() => {
    if (show) {
      document.body.style.overflow = 'hidden'; 
    } else {
      document.body.style.overflow = 'auto';
    }
    
    return () => {
      document.body.style.overflow = 'auto'; 
    };
  }, [show]);

 

      // ✅ Load SmartBox script
      useEffect(() => {
        const script = document.createElement("script");
        script.src = config.amwalpayURL;
        script.async = true;
        document.body.appendChild(script);
    
        return () => {
          document.body.removeChild(script);
        };
      }, []);

      const handleOrderDetails=(e,order_id)=>{
         e.preventDefault();
    window.location.href ='/hotel-order-status?order_id=' + order_id;
      }


  const handleStatus =(e,id)=>{
    e.preventDefault();
      // if (VendorKey) {
    
      //         const app_data={application_id:app_id}
      //           fetch(base_url + '/get_oman_visa_order_details', {
      //               method: 'POST',
      //               headers: {
      //                   "Authorization":"Bearer "+VendorKey,
      //                   'Content-Type': 'application/json'
      //               },
      //               body: JSON.stringify(app_data),
      //           })
      //           .then(response => response.json())
      //           .then(data => {
      //             if(data.message==="success"){
      //               // setApplicationData(data.result);
      //                setOdata(data.result);
      //               //  setOrddata(response.data.result.order.order_id);
      //                setShow(true);
      //             }
      //           })
      //           .catch(error => {
      //             toast.error(error.message)
      //               console.error('Error fetching oman visa app :', error);
      //           });
      //       }


    
    const search_hotel_orders= profile.filter((obj)=>obj.id===id);
                     setOdata(search_hotel_orders[0]);
                     console.log(search_hotel_orders[0])
                    //  setOrddata(response.data.result.order.order_id);
                     setShow(true);
  }


 const calculatePagination = (page,list) => {
    debugger
    const indexOfLastItem = page * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    setIndexOfLastItem(indexOfLastItem);
    setindexOfFirstItem(indexOfFirstItem);
    const currentItem = list.slice(indexOfFirstItem, indexOfLastItem);
    currentItemsdata(currentItem);
  };
  
  const handleNextPage = () => {
    debugger
    setCurrentPage((prevPage) => {
      const newPage = prevPage < totalPages ? prevPage + 1 : prevPage;
      if(profile.length > 0){
        calculatePagination(newPage,profile);
      }
      return newPage;
    });
  };
  
  const handlePrevPage = () => {
    setCurrentPage((prevPage) => {
      const newPage = prevPage > 1 ? prevPage - 1 : prevPage;
      if(profile.length > 0){
        calculatePagination(newPage,profile);
      }
      // calculatePagination(newPage,insuranceData);
      return newPage;
    });
  };


  const getButtonClass = (page) =>
    `btn btn-link w-100   text-decoration-none ${
      filter === page ? "btn btn-primary text-light" : "text-dark"
    }`;

  useEffect(()=>{

    if(pageChanged && tableRef.current){
  tableRef.current.scrollIntoView({ behavior: "smooth"});
      }
      else{
        console.log("element not found");
      }
      return ()=>{
        setPageChanged(false);
      }
  },[pageChanged]);

  const getHotelOrderDetails = async () => {
       setLoading(true);
       setCurrentPage(1);
        var get_order_url = base_url+"/get_hotel_orders_list";
        
        debugger
        fetch(get_order_url, {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${VendorKey}`,
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(Payload),
        })
          .then(response => response.json())
          .then(data => {
            debugger
          // const testData = Array(15).fill(data.result[0]);
          // data.result = testData;
          if(filter==="success"){
            setLoading(false);
            const filterSuccess = data.result.filter(item => item.payment_status.toLowerCase() === 'success' );
            setProfile(filterSuccess);
             // Set total pages based on data length
        const totalPagesCount = Math.ceil(filterSuccess.length / itemsPerPage);
        totalPagess(totalPagesCount);

        // Initial page calculation
        calculatePagination(1,filterSuccess);
          }
          else if(filter==="pending"){
             setLoading(false);
            const filterPending = data.result.filter(item => item.payment_status.toLowerCase() !== 'success' && item.is_deleted=="no");
            setProfile(filterPending);
             // Set total pages based on data length
        const totalPagesCount = Math.ceil(filterPending.length / itemsPerPage);
        totalPagess(totalPagesCount);

        // Initial page calculation
        calculatePagination(1,filterPending);
          }
          })
          .catch(error => {
            console.error('Error fetching countries:', error);
          });
        }
  
  useEffect(() => {

      // const location  = new URL(window.location.href);
      // const staffid = location.searchParams.get('staff_id');


      //   var vkData = { token: usrtok, user_type: "agent", staff_id: staffid };
      if(VendorKey){
           getHotelOrderDetails();
        }
    }, [ VendorKey,Payload,filter]);


  const handleRemove = async(e,card_id) => {
    e.preventDefault();
    if(!card_id){
      return;
    }
    debugger;
    setLoading(true);
     fetch(base_url+"/hotel_order_cancel",{
          method:"POST",
          headers:{
            "Authorization":"Bearer "+VendorKey,
            "Content-Type":"application/json"
          },
          body:JSON.stringify({card_id:card_id})
        }).then((response)=>response.json())
        .then((data)=>{
          if(data.message==="success"){
            //  setFilter("pending");
             getHotelOrderDetails();
          }
        }).catch(err=>console.error("while updating application status err : "+err))
        .finally(() => {
          setLoading(false);
        });
  }


    const getUserType = () => {
    if (userData.agency_name) return "agent";
    if (userData.type === "staff" && userData.staff_first_name) return "staff";
    if(userData.first_name && userData.last_name)  return "user";
    return "";
  };

   const openPaymentGateway = async (app_id) => {
    if (!app_id || !VendorKey) {
      console.error(" Missing appId or vendorKey");
      return;
    }

    setLoading(true);

    const pay_data = {
      application_id: app_id,
      user_type: getUserType(),
      is_live: "true",
      save_selection: "true",
      currency: "OMR",
      fee_omr: 45,
      description: "Oman Visa Payment",
      token: userData.access_token,
    };

    try {
      const res = await fetch(`${base_url}/create_oman_visa_payment`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${VendorKey}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(pay_data),
      });

      if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);

      const result = await res.json();
      if (result.message === "success") {
        const parsedata = JSON.parse(result.result.payment_details);
        const { secureHash, trxParams } = parsedata;

        if (!window.SmartBox || !window.SmartBox.Checkout) {
          throw new Error("SmartBox payment gateway not loaded");
        }

        window.SmartBox.Checkout.configure = {
          MID: trxParams.MerchantId,
          TID: trxParams.TerminalId,
          CurrencyId: trxParams.CurrencyId,
          AmountTrxn: trxParams.Amount,
          MerchantReference: trxParams.MerchantReference,
          LanguageId: "en",
          PaymentViewType: 1,
          TrxDateTime: trxParams.TrxDateTime,
          SessionToken: trxParams.SessionToken,
          SecureHash: secureHash,

          completeCallback: async (data) => {
            setLoading(true)
            try {
              const verifyRes = await axios.post(
                `${base_url}/oman_visa_payment_status`,
                data.data
              );
              if (verifyRes.valid) {
                window.location.href = verifyRes.data;
              }
            } catch (err) {
              console.error("Verification failed:", err);
            } 
          },

          errorCallback: (error) => {
            console.error("❌ Payment Error:", error);
            setLoading(false);
          },

          cancelCallback: (cancel) => {
            console.log("⚠️ Payment Cancelled:", cancel);
            setLoading(false);
          },
        };

        window.SmartBox.Checkout.showSmartBox();
      } else {
        throw new Error(result.message || "Payment creation failed");
      }
    } catch (err) {
      console.error("Error creating payment:", err);
      setLoading(false);
    }finally{
      setLoading(false);
    }
  };

      const handleProceedPayment = async (hotelObj) => {

        setLoading(true);
     
        const  usrtok=userData?.access_token;
       const data = {
            "hotel_id":hotelObj?.hotel_offer_id,
            "hotel_card_id":hotelObj?.id,
            "amount_cents": hotelObj?.price, //
            "is_live": "true",
            "first_name": hotelObj?.first_name,
            "last_name":hotelObj?.last_name,
            "phone_no": hotelObj?.phones,
            "email":hotelObj?.emails,
            "save_selection": "true",
            "redirection_url": base_url+"/hotel_payment_log_info",
            "currency": hotelObj?.currency, //
            "description": "Payment hotel **",
            "token":usrtok,
            "room_id":hotelObj?.room_id
          };
       
    // debugger
    if (VendorKey !== ''&&usrtok!=='') {
    
      fetch(base_url+'/ehotel_payments', {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${VendorKey}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      })
        .then(response => response.json())
        .then(data => {
          setLoading(false);
          if (data.message === "success") {
        var parsedata = JSON.parse(data.result.payment_details)
        const { secureHash, trxParams } = parsedata;
        window.SmartBox.Checkout.configure = {
          MID: trxParams.MerchantId,
          TID: trxParams.TerminalId,
          CurrencyId: trxParams.CurrencyId,
          AmountTrxn: trxParams.Amount,
          MerchantReference: trxParams.MerchantReference,
          LanguageId: "en",
          PaymentViewType: 1,
          TrxDateTime: trxParams.TrxDateTime,
          SessionToken: trxParams.SessionToken,
          SecureHash: secureHash,
          completeCallback: async (resp) => {
            
            console.log("✅ Payment success:", resp.data);
            setLoading(true);
            // Verify payment
            const verifyRes = await fetch(base_url + "/ehotel_payment_update", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify(resp.data),
            });
            const verifyJson = await verifyRes.json();
            if (verifyJson.valid === true) {
              window.location.href = verifyJson.data;
            }
          },
          errorCallback: (err) => {
            setLoading(false);
            //  window.location.href = `${config.redirectURL}/sanad-visapayment-cancel`;
            //  window.location.href = `${config.redirectURL}/sanad-visa-order-status?ref_no=${OrderDetails.sanad_reference_no}`;
            console.error("❌ Payment error:", err)
        },
          cancelCallback: () => {
            console.warn("⚠️ Payment cancelled")
        }
        };

        window.SmartBox.Checkout.showSmartBox();
      }
          // debugger
          // if(data.message==="success"){
          //   window.location.href = data.result?.client_url;
          // }
    
          // setpKey(data.result.payment_token);
    
    
        })
        .catch(error => {
          console.error('Error posting data:', error);
        });
    
    }  
      };

    

  const handlePayment = (e,hotelObj) => {
      e.preventDefault();
       setTimeout(()=>{
                      handleProceedPayment(hotelObj);
                  },1000);
  
  };


  return (
    <div>


      <div className="features_section my-1">
         <div className="container">

                <div className="row  d-flex justify-content-end">
           
                
                <div className="col-lg-4 col-md-6 pt-5 ">
                  <div className="w-100 orders-table">    
                <ul className={`list-unstyled mb-0 p-0 d-flex justify-content-end ${lnstr=="ar"?"mr-3":"ml-3"}`}>
                  <li  style={{ 
                    // flex: "1 1 0", /* grow, shrink, basis */
          textAlign: "center",
          border: "1px solid #ccc",
          // borderTopLeftRadius:"5px",
          // borderBottomLeftRadius:"5px",
         backgroundColor:filter==="success"?"#3fd2f2":"",
          //  borderRadius:"20px 0px 0px 20px"
          }}>
                    <button
                      className={getButtonClass("success")}
                      style={{ fontSize: "18px",textAlign:"center",  borderRadius:"20px 0px 0px 20px" }}
                      onClick={(e) => {e.preventDefault(); setFilter("success")}}
                    >
                      {t("Success")}
                    </button>
                  </li>
                  <li   style={{ 
                    // flex: "1 1 0", /* grow, shrink, basis */
          textAlign: "center",
          border: "1px solid #ccc",
          backgroundColor:filter==="pending"?"#3fd2f2":"",
          // borderRadius:"0px 20px 20px 0px"
         }}>
                    <button
                      className={getButtonClass("pending")}
                      style={{ fontSize: "18px" ,textAlign:"center",  borderRadius:"0px 20px 20px 0px"}}
                      onClick={(e) => {e.preventDefault();  setFilter("pending")}}
                    >
                      {t("Pending")}
                    </button>
                  </li>
                </ul>
                </div>
        
               
             
        </div>
        </div>
          <div className="row g-4 justify-content-center">

            <div className="col-12 wow fadeInUp" data-wow-delay="0.2s" style={{ overflowX: 'auto' }}>
              {/* { userData != null && userData != undefined && userData.agency_name != null && userData.agency_name != undefined ?

              <div className='row'>
                <div className='col-6'><b style={{ textTransform: 'uppercase', fontSize: 17 }}>{userData.agency_name != null && userData.agency_name != undefined ? userData.agency_name: <span>{userData.first_name} {userData.last_name}</span>}</b></div>
                
              </div> : <></>

               } */}

              {
                <div className="orders-table" ref={tableRef}>
         
                
                <table  className='table table-bordered mt-3'>
                                   <thead ><tr><th rowSpan={2} >#</th>
                                   
                                   {filter==="success"&& <th rowSpan={2}>{t('Order ID')}</th>}
                                    <th rowSpan={2}>{t('First Name')}</th>
                                    <th rowSpan={2}>{t('Last Name')}</th> 
                                    <th rowSpan={2}>{t('Email')}</th> 
               
                                     <th rowSpan={2} >{t('Mobile No')}</th>
                                     <th rowSpan={2} >{t('Hotel Name')}</th>
                                     
                                     
                                    <th rowSpan={2}>{t("Hotel Address")}</th>
                                    <th rowSpan={2}>{t("Guest Count")}</th>
                                    <th rowSpan={2}>{t("Payment Status")}</th>
                                      <th rowSpan={2}>{t('View')}</th>
                                     {filter!=="success" && <th rowSpan={2} colSpan={2} style={{textAlign:"center"}}>{t('Action')}</th>}
               
                                     </tr>
                                     
                                     {/* <tr><th style={{ width: '15%' }}>{t('From')}</th>
                                     <th style={{ width: '15%' }}>{t('To')}</th></tr> */}
               
                                     </thead>
                                   <tbody>
               
                                     {(currentItems?.length === 0) ? <tr><td colSpan={8} className='text-center'>{t('No')} {t('Records')} {t('Found')}</td></tr> : ''}
                                     {currentItems?.map((prof, index) => {
                                       return (
                                         <tr key={index}>
                                           <td>{indexOfFirstItem+index + 1}</td>
                                           {filter==="success"&& <td>{t(prof.order_id)}</td>}
                                           {/* <td>{format(new Date(prof.created_at), 'dd/MM/yyyy')}</td> */}
                                          <td>{t(prof.first_name)}</td>
                                          <td>{t(prof.last_name)}</td>
                                          <td>{t(prof.emails)}</td>
                                          <td>{t(prof.phones)}</td>
                                          <td>{t(prof.hotel_name)}</td>
                                          <td>{t(prof.hotel_address)}</td>
                                          <td>{t(prof.total_guest_count)}</td>
                                          <td>{t(prof.payment_status)}</td>
                                          
                                     { <td>
                                             <Button
                                               variant="primary"
                                               style={{ fontWeight: 'normal' }}
                                               className="btn btn-primary rounded-pill text-white py-1 px-2"
                                               onClick={(e)=>handleStatus(e,prof?.id)}
                                             >
                                             {t('View')}
                                             </Button>
                                           </td>
                                     }
                                               { filter !== "success" && 
                                          <>
                                          <td>
                                           {/* Download Button */}
                                           
                                           {/* Download Button */}
                                           <button
                                             onClick={(e) => handlePayment(e,prof)}
                                              className="btn btn-primary rounded-pill text-white py-1 px-2"
                                             // onClick={() => openIframe(`https://superjet.simplevisa.net/travellers/deeplinks/sign_in/FQ6RtrhUmQgeZwHClSPGopP7l8x8djBAWQIIdrO13FM`)}
                                             style={{ background: "none", border: "none", cursor: "pointer" }}
                                           >
                                             {t("Pay")}
                                           </button>
                                      
                                         </td>
                                           <td>
                                             <Button
                                               variant="primary"
                                               style={{ fontWeight: 'normal' }}
                                               className="btn btn-primary rounded-pill text-white py-1 px-2"
                                               onClick={(e) => handleRemove(e, prof?.id)}
                                             >
                                             {t('Cancel')}
                                             </Button>
                                           </td>
                                           </>}
                                         </tr>
                                       );
                                     })}
                                   </tbody>
                                 </table> 
                </div>
              }
              {totalPages === 0 ? <div></div> : <div className="pagination-controls-new">
                <button onClick={handlePrevPage} disabled={currentPage === 1}>
                  ‹
                </button>
                <span>

                </span>
                <span>
                  {t('Page')} {currentPage} {t('of')} {totalPages}
                </span>
                <span>

                </span>
                <button onClick={handleNextPage} disabled={currentPage === totalPages}>
                  ›
                </button>
              </div>}
              {/* {userData != null && userData != undefined && userData.agency_name != null && userData.agency_name != undefined && <h3 style={{textAlign:"right"}}>{t('Total')} {t('Earnings')} :  {totalEarnings}</h3>} */}
            </div>
          </div>
        </div>
      </div>
      


      {/* <Footer /> */}
        {loading && (
        <div className="overlay">
          <div className="spinner"></div>
        </div>
      )}



     


      {show && (
        <div className='modal'>
          <div className='modal-content' style={{height:"auto" , width:'700px'}}>
          <h2><span>{t('Order')} {t('Status')}</span></h2>
          <button type="button" className="close" onClick={handleClose}>
          &times;
          </button>
          <div style={{height:'20px'}}></div>
          <div className='d-flex  justify-content-center'>

            <table style={{  width:'250'}}>
           {odata?.order_id && <tr><td style={{ fontWeight: 'bold', textAlign:'left' ,width:"30%"}}>{t('Order ID')}</td><td style={{ fontWeight: 'bold', textAlign:'left'}}>:</td><td style={{textAlign:'left'}}><b>{odata?.order_id}</b></td></tr>}


            <tr><td style={{ fontWeight: 'bold', textAlign:'left' }}>{t('Status')}</td><td style={{ fontWeight: 'bold', textAlign:'left'}}>:</td><td style={{ textTransform: 'capitalize', textAlign:'left' }}><b>{odata?.payment_status != null && odata?.payment_status != undefined ? odata?.payment_status : ""}</b></td></tr>


            <tr><td style={{ fontWeight: 'bold', textAlign:'left' }}>{t('First Name')}</td><td style={{ fontWeight: 'bold', textAlign:'left'}}>:</td><td style={{ textTransform: 'capitalize', textAlign:'left' }}><b>{odata?.first_name != null && odata?.first_name != undefined ? odata?.first_name : ''}</b></td></tr>
            <tr><td style={{ fontWeight: 'bold', textAlign:'left' }}>{t('Last Name')}</td><td style={{ fontWeight: 'bold', textAlign:'left'}}>:</td><td style={{ textTransform: 'capitalize', textAlign:'left' }}><b>{odata?.last_name != null && odata?.last_name != undefined ? odata?.last_name : ''}</b></td></tr>

      
        
            <tr><td style={{ fontWeight: 'bold', textAlign:'left' }}>{t('Email')}</td><td style={{ fontWeight: 'bold', textAlign:'left'}}>:</td><td style={{textAlign:'left'}}><b>{odata?.emails != null && odata?.emails != undefined ? odata.emails : ''}</b></td></tr>
            <tr><td style={{ fontWeight: 'bold', textAlign:'left' }}>{t('Mobile No')}</td><td style={{ fontWeight: 'bold', textAlign:'left'}}>:</td><td style={{textAlign:'left'}}><b>{odata?.phones != null && odata?.phones != undefined ? odata.phones : ''}</b></td></tr>
            <tr><td style={{ fontWeight: 'bold', textAlign:'left' }}>{t('Checkin Date')}</td><td style={{ fontWeight: 'bold', textAlign:'left'}}>:</td><td style={{textAlign:'left'}}><b>{odata?.checkin_date != null && odata?.checkin_date != undefined ? odata.checkin_date.split("T")[0] : ''}</b></td></tr>
            <tr><td style={{ fontWeight: 'bold', textAlign:'left' }}>{t('Checkout Date')}</td><td style={{ fontWeight: 'bold', textAlign:'left'}}>:</td><td style={{textAlign:'left'}}><b>{odata?.checkout_date != null && odata?.checkout_date != undefined ? odata.checkout_date.split("T")[0] : ''}</b></td></tr>
               <tr><td style={{ fontWeight: 'bold', textAlign:'left' }}>{t('Hotel Name')}</td><td style={{ fontWeight: 'bold', textAlign:'left'}}>:</td><td style={{textAlign:'left'}}><b>{odata?.hotel_name != null && odata?.hotel_name != undefined ? odata.hotel_name : ''}</b></td></tr>
               <tr><td style={{ fontWeight: 'bold', textAlign:'left' }}>{t('Total Guest Count')}</td><td style={{ fontWeight: 'bold', textAlign:'left'}}>:</td><td style={{textAlign:'left'}}><b>{odata?.total_guest_count != null && odata?.total_guest_count != undefined ? odata.total_guest_count : ''}</b></td></tr>
               <tr><td style={{ fontWeight: 'bold', textAlign:'left' }}>{t('Rooms Count')}</td><td style={{ fontWeight: 'bold', textAlign:'left'}}>:</td><td style={{textAlign:'left'}}><b>{odata?.rooms_count != null && odata?.rooms_count != undefined ? odata.rooms_count : ''}</b></td></tr>
            <tr><td style={{ fontWeight: 'bold', textAlign:'left' }}>{t('Price')}</td><td style={{ fontWeight: 'bold', textAlign:'left'}}>:</td><td style={{textAlign:'left'}}><b>{odata?.price != null && odata?.price != undefined ? odata.price : ''}{" "}{odata?.currency != null && odata?.currency != undefined ? odata.currency: ''}</b></td></tr>
            <tr><td style={{ fontWeight: 'bold', textAlign:'left'  }}>{t('Date Created')}</td><td style={{paddingRight: 10  , fontWeight: 'bold', textAlign:'left'}}>:</td><td style={{ textTransform: 'capitalize', textAlign:'left' }}><b>{odata?.created_at != null && odata?.created_at != undefined ? odata?.created_at.split('T')[0] : ''}</b></td></tr>
          </table>
        
          </div>
          <div>
              <button type="button"   class="btn  btn-close d-none d-md-inline-block" aria-label="Close" onClick={handleClose}>{t("Close")}</button>
  {odata.order_id && <button type="button"   class={`btn  ${lnstr=="en"?"ml-3":"mr-3"} btn-close `} aria-label="Close" onClick={(e)=>handleOrderDetails(e,odata.order_id)}>{t("Full Details")}</button>}
            </div>
          </div>
        </div>
      )}





     

     </div>
  );
};

export default MyHotelsTable;